import React from "react";
import { connect } from "react-redux";
import { Container, Row, Col, Card, CardHeader, CardBody, Table, Badge as BadgeUI } from "reactstrap";
import reduxHelper from "./../../../helper/index.js";
import SimpleHeader from "./../../../components/Headers/SimpleHeader.jsx";
import Avatar from "./../badge/Avatar.jsx";
import LevelBadge from "./LevelBadge.jsx";
import { formatXp, getStreakColor } from "./../../../helper/xpHelpers.js";

class GlobalLeaderboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: true };
    this.helper = new reduxHelper(this.props);
  }

  async componentDidMount() {
    await Promise.all([
      this.helper.gamification().getLeaderboard(50),
      this.helper.gamification().getTopStreaks(10),
      this.helper.gamification().getLevelList()
    ]);
    this.setState({ loading: false });
  }

  getLevelName(levelNumber) {
    var list = (this.props.gamification && this.props.gamification.levelList) || [];
    var found = list.find(function (l) { return l.level === levelNumber; });
    return found ? found.name : ('Nível ' + levelNumber);
  }

  getLevelIcon(levelNumber) {
    var list = (this.props.gamification && this.props.gamification.levelList) || [];
    var found = list.find(function (l) { return l.level === levelNumber; });
    return found ? found.icon : 'fas fa-medal';
  }

  getRankIcon(index) {
    if (index === 0) return <i className="fas fa-trophy" style={{ color: '#FFD700', fontSize: '1.4rem' }} />;
    if (index === 1) return <i className="fas fa-medal" style={{ color: '#C0C0C0', fontSize: '1.2rem' }} />;
    if (index === 2) return <i className="fas fa-medal" style={{ color: '#CD7F32', fontSize: '1.1rem' }} />;
    return <span className="text-muted font-weight-bold">{index + 1}º</span>;
  }

  render() {
    var leaderboard = (this.props.gamification && this.props.gamification.leaderboard) || [];
    var topStreaks = (this.props.gamification && this.props.gamification.topStreaks) || [];
    var myUserId = this.props.user ? this.props.user.id : null;

    return (
      <React.Fragment>
        {!this.props.embedded && <SimpleHeader name="Ranking Global" way={[{ name: "Conquistas", url: "/leaderboard" }]} />}
        <Container className={this.props.embedded ? "mt-3" : "mt--6"} fluid>
          <Row>
            {/* Leaderboard XP */}
            <Col xl="8">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <h3 className="mb-0">
                    <i className="fas fa-trophy text-warning mr-2" />
                    Ranking de XP — Top 50
                  </h3>
                </CardHeader>
                <CardBody className="p-0">
                  {this.state.loading ? (
                    <div className="text-center py-4"><i className="fas fa-spinner fa-spin fa-2x text-muted" /></div>
                  ) : leaderboard.length === 0 ? (
                    <p className="text-center text-muted py-4">Sem dados ainda</p>
                  ) : (
                    <Table responsive hover className="align-items-center mb-0">
                      <thead className="thead-light">
                        <tr>
                          <th style={{ width: '60px' }}>#</th>
                          <th>Aluno</th>
                          <th className="text-center">Nível</th>
                          <th className="text-right">XP</th>
                        </tr>
                      </thead>
                      <tbody>
                        {leaderboard.map((item, index) => {
                          var isMe = myUserId && parseInt(item.user) === parseInt(myUserId);
                          return (
                            <tr key={item.user} style={{ backgroundColor: isMe ? '#FFF8E1' : (index < 3 ? '#FAFAFA' : 'transparent') }}>
                              <td className="text-center">{this.getRankIcon(index)}</td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <Avatar user={{ id: item.user, photo: item.photo }} size={40} />
                                  <div className="ml-2">
                                    <strong>{item.name} {item.lastName || ''}</strong>
                                    {isMe && <BadgeUI color="warning" pill className="ml-2" style={{ fontSize: '0.6rem' }}>VOCÊ</BadgeUI>}
                                  </div>
                                </div>
                              </td>
                              <td className="text-center">
                                <LevelBadge
                                  level={item.currentLevel}
                                  name={this.getLevelName(item.currentLevel)}
                                  icon={this.getLevelIcon(item.currentLevel)}
                                  size={36}
                                />
                              </td>
                              <td className="text-right">
                                <strong style={{ fontSize: '1.05rem', color: '#FF9800' }}>
                                  {formatXp(item.totalXp)} XP
                                </strong>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  )}
                </CardBody>
              </Card>
            </Col>

            {/* Top Streaks */}
            <Col xl="4">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <h4 className="mb-0">
                    <i className="fas fa-fire" style={{ color: '#FF5722' }} /> Top Streaks
                  </h4>
                </CardHeader>
                <CardBody>
                  {topStreaks.length === 0 ? (
                    <p className="text-center text-muted">Nenhum streak ainda</p>
                  ) : (
                    topStreaks.map((s, idx) => (
                      <div key={s.user} className="d-flex align-items-center py-2" style={{ borderBottom: idx < topStreaks.length - 1 ? '1px solid #eee' : 'none' }}>
                        <span className="mr-2 text-muted" style={{ fontWeight: 700, width: '20px' }}>{idx + 1}</span>
                        <Avatar user={{ id: s.user, photo: s.photo }} size={32} />
                        <div className="flex-grow-1 ml-2">
                          <small className="d-block"><strong>{s.name} {s.lastName || ''}</strong></small>
                        </div>
                        <span style={{ color: getStreakColor(s.currentStreak), fontWeight: 700 }}>
                          <i className="fas fa-fire mr-1" />{s.currentStreak}
                        </span>
                      </div>
                    ))
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default connect(state => ({
  user: state.user,
  gamification: state.gamification,
  translate: state.translate
}))(GlobalLeaderboard);
